import { SimpleGrid, SimpleGridProps } from 'ui/core'

export interface CatalogueProps extends SimpleGridProps {}

const Catalogue = (props: CatalogueProps) => (
  <SimpleGrid spacing="md" cols={{ base: 1, sm: 2, md: 3, lg: 4 }} {...props} />
)

export default Catalogue
